import { remoteConfig } from "services/firebase";
import { updateConfig } from "../services/Functions";

const RemoteConfigService = {
  setValue: (key, value) => updateConfig({ key, value }),
  getValue: (key) => remoteConfig.getValue(key),
  getValues: () => remoteConfig.getAll(),
};

export default RemoteConfigService;
